import api from '../axios'

// 浏览器端聚合页包含多个配置区块，生产环境偶发响应超过 3 秒；
// SSR 等有严格耗时预算的调用方仍可通过 config.timeout 覆盖该默认值。
const AGGREGATE_PAGE_TIMEOUT_MS = 10_000

function normalizeKey(value) {
  return encodeURIComponent(String(value || '').trim())
}

function buildAggregatePageConfig(params, config) {
  return {
    params,
    showError: false,
    timeout: AGGREGATE_PAGE_TIMEOUT_MS,
    ...config,
  }
}

export const aggregatePageApi = {
  list: (params = {}, config = {}) =>
    api.get('/p/store/aggregate-pages', buildAggregatePageConfig(params, config)),

  getByKey: (pageKey, params = {}, config = {}) =>
    api.get(
      `/p/store/aggregate-pages/by-key/${normalizeKey(pageKey)}`,
      buildAggregatePageConfig(params, config)
    ),

  getCategoryPage: (categoryId, params = {}, config = {}) =>
    api.get(
      `/p/store/aggregate-pages/category/${normalizeKey(categoryId)}`,
      buildAggregatePageConfig(params, config)
    ),
}
